export const styles = theme => ({
    title: {
        textOverflow: 'ellipsis',
    }
});
